/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React, { useEffect, useState } from 'react';
import { EmptyState, LinkButton, Page, Skeleton } from '../components/console/ui';
import { UsersIc } from '../components/console/icons';
import ProjectsHeader from '../components/projects/ProjectsHeader';
import ProjectTeam from '../components/projects/ProjectTeam';
import { useSelectedProject } from '../hooks/useSelectedProject';

// Members & invitations of the project chosen in the global top-bar picker.
const ProjectMembers: React.FC = () => {
  const { selectedProjectId, selectedProject, projects, projectsLoading, autoSelectFirstProject } = useSelectedProject();
  const [memberCount, setMemberCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    autoSelectFirstProject();
  }, [autoSelectFirstProject]);

  useEffect(() => {
    setMemberCount(undefined);
  }, [selectedProjectId]);

  return (
    <Page>
      <ProjectsHeader
        subtitle={
          selectedProject ? (
            <>
              Members of <b className="text-ps-text font-semibold">{selectedProject.name}</b>. Switch project from the top
              bar.
            </>
          ) : (
            'Members of the selected project. Switch project from the top bar.'
          )
        }
        projectCount={projects.length}
        memberCount={memberCount}
      />

      {projectsLoading ? (
        <Skeleton className="h-40 rounded-[14px]" />
      ) : !selectedProjectId || !selectedProject ? (
        <EmptyState
          icon={<UsersIc />}
          title={projects.length === 0 ? 'No projects yet' : 'Pick a project'}
          body={
            projects.length === 0
              ? 'Create a project first, then invite people to it.'
              : 'Choose a project in the top bar to see and manage its members.'
          }
          actions={projects.length === 0 ? <LinkButton to="/projects">Go to projects</LinkButton> : undefined}
        />
      ) : (
        <ProjectTeam
          key={selectedProjectId}
          projectId={selectedProjectId}
          ownerId={selectedProject.owner_id}
          onMemberCount={setMemberCount}
        />
      )}
    </Page>
  );
};

export default ProjectMembers;
